import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const renameSuite = async ({ suiteId, newName }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=editTestSuites&companyid=${user.companyid}&idtest_suite=${suiteId}&newName=${newName}`,
  );

  return response.data;
};

const useReNameTestSuite = ({ onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: renameSuite,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(["testSuiteNew"]);
      if (onSuccess) {
        onSuccess(data, variables);
      }
    },
    onError: onError,
  });

  const refetchWithParams = (id, value) => {
    mutation.mutate({ suiteId: id, newName: value });
  };

  return {
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,

    refetchWithParams,
    reset: mutation.reset,
    status: mutation.status,
  };
};

export default useReNameTestSuite;
